import { config } from '../config';
import { User } from '../../types/api';
import { tokenManager } from '../auth/tokenManager';

export const searchApi = {
  searchByName: async (userId: number, query: string): Promise<User[]> => {
    const response = await tokenManager.makeAuthenticatedRequest(`${config.API_URL}/user/${userId}/search?query=${encodeURIComponent(query)}`);

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.detail || data.message || 'Failed to search users');
    }

    return data;
  }
};
